import { render } from "./Minutes.vue?vue&type=template&id=07c74164"
import script from "./Minutes.vue?vue&type=script&lang=js"
export * from "./Minutes.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__